import _ from 'lodash';
import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import API from '../../../app/api';
import {setSnackbar} from '../../../store/reducers/globals';

const useBays = (wardId, hospitalId) => {
    const controller = new AbortController();
    const dispatch = useDispatch();
    
    const [bays, setBays] = useState([]);
    const [baysLoading, setBaysLoading] = useState(false);
    
    useEffect(() => {
        if (wardId) {
            setBaysLoading(true);
            API.getAllAreas(wardId, controller.signal)
                .then(zones => {
                    const filteredBays = _.filter(zones?.data, bay => !bay?.envObject && bay?.type !== 'list' && (hospitalId ? bay?.hospitalId === hospitalId : true));
                    setBays(filteredBays || []);
                })
                .catch(err => {
                    console.error(err);
                    dispatch(setSnackbar({
                        type: 'error',
                        message: `There was a problem getting bays for ward id ${wardId}`,
                    }));
                })
                .finally(() => {
                    setBaysLoading(false);
                });
        }
    }, [wardId]);
    
    useEffect(() => {
        return () => {
            controller.abort();
        };
    }, []);
    
    
    return [bays, baysLoading];
}

export default useBays;